import { render, staticRenderFns } from "./Licenses.vue?vue&type=template&id=5ed96f09&scoped=true"
import script from "./Licenses.vue?vue&type=script&lang=js"
export * from "./Licenses.vue?vue&type=script&lang=js"
import style0 from "./Licenses.vue?vue&type=style&index=0&id=5ed96f09&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed96f09",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ed96f09')) {
      api.createRecord('5ed96f09', component.options)
    } else {
      api.reload('5ed96f09', component.options)
    }
    module.hot.accept("./Licenses.vue?vue&type=template&id=5ed96f09&scoped=true", function () {
      api.rerender('5ed96f09', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/admin/OrganisationDetails/Licenses.vue"
export default component.exports